import React, { FC, useMemo } from 'react';
import useEEActive from '../../../hooks/useEEActive';
import ctaTypes from '../../../enums/CTA.enums';
import CTA from '../CTA';
import TextComponentDecider from '../TextComponentDecider';
import { HeadingModel } from './model/heading.model';
import { THeadingProps } from './types/heading.types';
import { targetLinkdsk } from '../../../utils/targetDskLink';
import useMediaQuery from '../../../hooks/useMediaQuery';
import breakpoints from '../../../constants/breakpoints.constants';
import { getTextType } from '../../../utils/getTextType.utils';
import './styles.scss';

const Heading: FC<THeadingProps> = (props) => {
  const model = useMemo(() => new HeadingModel(props), [props]);
  const {
    extraClassNameLink = '',
    children,
    customTextTitle = false,
    customTextSubtitle = false,
    richTextTitle = false,
    tag = 'h2',
    isGenericPopup,
    useDictionaryFallback = false,
    titleDictionaryKey,
    eyebrowDictionaryKey,
    descriptionDictionaryKey,
  } = props;
  const isEE = useEEActive();
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);
  const titleTextType = model.titleTextType(customTextTitle, richTextTitle);
  const subtitleTextType = model.subtitleTextType(customTextSubtitle);

  const headingEyebrow = (model.eyebrow || isEE || useDictionaryFallback) && (
    <TextComponentDecider
      type={getTextType('Text', !model.eyebrow?.value)}
      tag={'span'}
      field={model.eyebrow}
      className="heading__eyebrow"
      editable={model.editable}
      dictionaryKey={eyebrowDictionaryKey}
    />
  );

  const headingGenericPopupCTA = isGenericPopup && (Boolean(children) || isEE) && (
    <span className="heading__generic-popup">{children}</span>
  );

  const headingTitle = (model.title || isEE || useDictionaryFallback) && (
    <TextComponentDecider
      type={getTextType(titleTextType, !model.title?.value)}
      tag={tag}
      field={model.title}
      className="heading__title"
      editable={model.editable}
      dictionaryKey={titleDictionaryKey}
    />
  );

  const headingLinkCTA = (model.isLinkExists || isEE) && (
    <span className={`heading__link ${extraClassNameLink}`}>
      <CTA type={ctaTypes.secondaryBlack} field={model.link} target={targetLinkdsk(model?.link, isDesktop)} />
    </span>
  );

  const headingSubtitle = (model.subtitle || isEE || useDictionaryFallback) && (
    <TextComponentDecider
      type={getTextType(subtitleTextType, !model.subtitle?.value)}
      tag="div"
      field={model.subtitle}
      className={`heading__subtitle rich-text ${isGenericPopup ? 'heading__subtitle--margin-bottom' : ''}`}
      editable={model.editable}
      dictionaryKey={descriptionDictionaryKey}
    />
  );

  return isDesktop ? (
    <div className="heading">
      {headingEyebrow}
      <div className={`heading__title-wrapper ${isGenericPopup ? 'heading__title-wrapper--margin-bottom' : ''}`}>
        {headingTitle}
        {headingLinkCTA}
      </div>
      {headingGenericPopupCTA}
      {headingSubtitle}
    </div>
  ) : (
    <div className="heading">
      {headingEyebrow}
      {headingTitle}
      {headingSubtitle}
      <div className="heading__link-wrapper">
        {headingLinkCTA}
        {headingGenericPopupCTA}
      </div>
    </div>
  );
};
export default React.memo(Heading);
